var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRateStar = function SvgRateStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7299 4.01001L15.4899 7.53001C15.7299 8.02001 16.3699 8.49001 16.9099 8.58001L20.0999 9.11001C22.1399 9.45001 22.6199 10.93 21.1499 12.39L18.6699 14.87C18.2499 15.29 18.0199 16.1 18.1499 16.68L18.8599 19.75C19.4199 22.18 18.1299 23.12 15.9799 21.85L12.9899 20.08C12.4499 19.76 11.5599 19.76 11.0099 20.08L8.01991 21.85C5.87991 23.12 4.57991 22.17 5.13991 19.75L5.84991 16.68C5.97991 16.1 5.74991 15.29 5.32991 14.87L2.84991 12.39C1.38991 10.93 1.85991 9.45001 3.89991 9.11001L7.08991 8.58001C7.61991 8.49001 8.25991 8.02001 8.49991 7.53001L10.2599 4.01001C11.2199 2.10001 12.7799 2.10001 13.7299 4.01001Z",
    fill: "#FFC400"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRateStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rate-star.c409e86d.svg";
export { ForwardRef as ReactComponent };